import { ButtonFilled, IconCommonV2Props, Tooltip } from '@abtasty/design-system';
import { useTranslation } from 'react-i18next';
import { TestStatus, TestStatusCategory } from '../../../shared/tag/serializedTagTypes';
import { getTestStatusCategory } from '../../../shared/tag/helpers';
import { ForceTestTargetingEventData } from '@src/container/handleIframeMessage/types';
import { forceTestTargeting, isForceDisplayButtonDisabled } from '../../helpers';
import { ForceTestTargetingAction } from '@src/container/tag/forceTestTargeting';

type CampaignDisplayButtonProps = { id: number; status: TestStatus };
export function CampaignDisplayButton({ id, status }: CampaignDisplayButtonProps) {
  const { t } = useTranslation();

  const propsByCategory: Record<
    TestStatusCategory,
    { icon: IconCommonV2Props['icon']; label: string; action: ForceTestTargetingEventData['action'] } | null
  > = {
    [TestStatusCategory.accepted]: {
      icon: 'visibilityHide',
      label: t('Hide'),
      action: ForceTestTargetingAction.FORCE_REJECTED,
    },
    [TestStatusCategory.rejected]: {
      icon: 'visibilityShow',
      label: t('Force display'),
      action: ForceTestTargetingAction.FORCE_ACCEPTED,
    },
    [TestStatusCategory.forced]: {
      icon: 'refresh',
      label: t('Back to initial state'),
      action: ForceTestTargetingAction.FORCE_RESET,
    },
    [TestStatusCategory.waiting]: null,
  };

  const props = propsByCategory[getTestStatusCategory(status)];
  const disabledForceDisplayButton = isForceDisplayButtonDisabled(status);

  return props ? (
    <Tooltip
      content={
        disabledForceDisplayButton &&
        t(`You can't force the display of this campaign since page can't be verified or hasn't been verified yet`)
      }
    >
      <ButtonFilled
        variant="primary"
        size="small"
        icon={props.icon}
        iconPosition="left"
        label={props.label}
        onClick={() => forceTestTargeting(id, props.action)}
        disabled={disabledForceDisplayButton}
      />
    </Tooltip>
  ) : null;
}
